import { useCallback, useMemo } from 'react';
import { store } from 'redux/store';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroWBCultureSelectedGroupCP,
  setGroupCP,
} from 'redux/reducers/meteorologyAgroWBCultureReducer';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import useLocationGroups from '../../useLocationGroups';

export default function useGroup() {
  const { groups } = useLocationGroups();
  const selectedGroup = useSelector(selectMeteorologyAgroWBCultureSelectedGroupCP);
  const closeAccordion = useMemo(() => buildAccordionClickFunction('group-accordion'), []);

  const setGroup = useCallback((id: number) => () => {
    store.dispatch(setGroupCP(id));
    closeAccordion();
  }, [closeAccordion]);

  return {
    availableGroups: groups,
    selectedGroup,
    setGroup,
  };
}
